import { motion } from "framer-motion";

const EASE = [0.76, 0, 0.24, 1];

// Fade + rise reveal on scroll into view.
export const Reveal = ({ children, delay = 0, y = 40, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, ease: EASE, delay }}
    {...rest}
  >
    {children}
  </motion.div>
);

// Masked line-by-line reveal for headings. Pass an array of lines.
export const MaskedLines = ({ lines, className = "", lineClassName = "", delay = 0, once = true }) => (
  <span className={className}>
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden">
        <motion.span
          className={`block ${lineClassName}`}
          initial={{ y: "110%" }}
          {...(once
            ? { whileInView: { y: 0 }, viewport: { once: true, margin: "-40px" } }
            : { animate: { y: 0 } })}
          transition={{ duration: 1, ease: EASE, delay: delay + i * 0.09 }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);
